import { Grid, Typography } from '@mui/material';
import React, { memo } from 'react';
import DuplicateMember from './DuplicateMember';

function DuplicateMemberList({ members, view = 'page' }) {
  if (members.length === 0) {
    return <Typography>No duplicate members found</Typography>;
  }
  return (
    <Grid container spacing={2}>
      {members.map(member => (
        <Grid item md={view === 'dropdown' ? 6 : 4} key={member.id} xs={12}>
          <DuplicateMember member={member} />
        </Grid>
      ))}
    </Grid>
  );
}

export default memo(DuplicateMemberList);
